/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PatientVisitInstitutionalDetailsIntegrationViewModel {
  /**
   * Point Of Origin Code
   */
  pointOfOriginCode?: string | null;
  /**
   * Admission Type Code
   */
  admissionTypeCode?: string | null;
  /**
   * Discharge Status Code
   */
  dischargeStatusCode?: string | null;
  /**
   * Admit Hour
   */
  admitHour?: string | null;
  /**
   * Discharge Hour
   */
  dischargeHour?: string | null;
  /**
   * Billing Note
   */
  billingNote?: string | null;
  /**
   * Claim Note Type 1 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType1Code?: string | null;
  /**
   * Claim Note 1
   */
  claimNote1?: string | null;
  /**
   * Claim Note Type 2 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType2Code?: string | null;
  /**
   * Claim Note 2
   */
  claimNote2?: string | null;
  /**
   * Claim Note Type 3 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType3Code?: string | null;
  /**
   * Claim Note 3
   */
  claimNote3?: string | null;
  /**
   * Claim Note Type 4 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType4Code?: string | null;
  /**
   * Claim Note 4
   */
  claimNote4?: string | null;
  /**
   * Claim Note Type 5 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType5Code?: string | null;
  /**
   * Claim Note 5
   */
  claimNote5?: string | null;
  /**
   * Claim Note Type 6 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType6Code?: string | null;
  /**
   * Claim Note 6
   */
  claimNote6?: string | null;
  /**
   * Claim Note Type 7 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType7Code?: string | null;
  /**
   * Claim Note 7
   */
  claimNote7?: string | null;
  /**
   * Claim Note Type 8 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType8Code?: string | null;
  /**
   * Claim Note 8
   */
  claimNote8?: string | null;
  /**
   * Claim Note Type 9 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType9Code?: string | null;
  /**
   * Claim Note 9
   */
  claimNote9?: string | null;
  /**
   * Claim Note Type 10 Code, valid values: ADD,ALG,DCP,DGN,DME,MED,NTR,ODT,RHB,RLH,RNH,SET,SFM,SPT,UPI
   */
  claimNoteType10Code?: string | null;
  /**
   * Claim Note 10
   */
  claimNote10?: string | null;
  /**
   * Admitting Diagnosis Code
   */
  admittingDiagnosisCode?: string | null;
  /**
   * Admitting Diag Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  admittingDiagPresentOnAdmissionCode?: string | null;
  /**
   * Visit Reason 1 Diagnosis Code
   */
  visitReason1DiagnosisCode?: string | null;
  /**
   * Visit Reason 1 Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  visitReason1PresentOnAdmissionCode?: string | null;
  /**
   * Visit Reason 2 Diagnosis Code
   */
  visitReason2DiagnosisCode?: string | null;
  /**
   * Visit Reason 2 Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  visitReason2PresentOnAdmissionCode?: string | null;
  /**
   * Visit Reason 3 Diagnosis Code
   */
  visitReason3DiagnosisCode?: string | null;
  /**
   * Visit Reason 3 Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  visitReason3PresentOnAdmissionCode?: string | null;
  /**
   * Cause 1 Diagnosis Code
   */
  cause1DiagnosisCode?: string | null;
  /**
   * Cause 1 Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  cause1PresentOnAdmissionCode?: string | null;
  /**
   * Cause 2 Diagnosis Code
   */
  cause2DiagnosisCode?: string | null;
  /**
   * Cause 2 Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  cause2PresentOnAdmissionCode?: string | null;
  /**
   * Cause 3 Diagnosis Code
   */
  cause3DiagnosisCode?: string | null;
  /**
   * Cause 3 Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  cause3PresentOnAdmissionCode?: string | null;
  /**
   * Drg Diagnosis Code
   */
  drgDiagnosisCode?: string | null;
  /**
   * Drg Present On Admission Code, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  drgPresentOnAdmissionCode?: string | null;
  /**
   * Principal Procedure Code
   */
  principalProcedureCode?: string | null;
  /**
   * Principal Procedure Date
   */
  principalProcedureDate?: string | null;
  /**
   * Other Procedure 1 Code
   */
  otherProcedure1Code?: string | null;
  /**
   * Other Procedure 1 Date
   */
  otherProcedure1Date?: string | null;
  /**
   * Other Procedure 2 Code
   */
  otherProcedure2Code?: string | null;
  /**
   * Other Procedure 2 Date
   */
  otherProcedure2Date?: string | null;
  /**
   * Other Procedure 3 Code
   */
  otherProcedure3Code?: string | null;
  /**
   * Other Procedure 3 Date
   */
  otherProcedure3Date?: string | null;
  /**
   * Other Procedure 4 Code
   */
  otherProcedure4Code?: string | null;
  /**
   * Other Procedure 4 Date
   */
  otherProcedure4Date?: string | null;
  /**
   * Other Procedure 5 Code
   */
  otherProcedure5Code?: string | null;
  /**
   * Other Procedure 5 Date
   */
  otherProcedure5Date?: string | null;
  /**
   * Occurrence Span Code 1
   */
  occurrenceSpanCode1?: string | null;
  /**
   * Occurrence Span 1 From Date
   */
  occurrenceSpan1FromDate?: string | null;
  /**
   * Occurrence Span 1 To Date
   */
  occurrenceSpan1ToDate?: string | null;
  /**
   * Occurrence Span Code 2
   */
  occurrenceSpanCode2?: string | null;
  /**
   * Occurrence Span 2 From Date
   */
  occurrenceSpan2FromDate?: string | null;
  /**
   * Occurrence Span 2 To Date
   */
  occurrenceSpan2ToDate?: string | null;
  /**
   * Occurrence Code 1
   */
  occurrenceCode1?: string | null;
  /**
   * Occurrence 1 Date
   */
  occurrence1Date?: string | null;
  /**
   * Occurrence Code 2
   */
  occurrenceCode2?: string | null;
  /**
   * Occurrence 2 Date
   */
  occurrence2Date?: string | null;
  /**
   * Occurrence Code 3
   */
  occurrenceCode3?: string | null;
  /**
   * Occurrence 3 Date
   */
  occurrence3Date?: string | null;
  /**
   * Occurrence Code 4
   */
  occurrenceCode4?: string | null;
  /**
   * Occurrence 4 Date
   */
  occurrence4Date?: string | null;
  /**
   * Value Code 1
   */
  valueCode1?: string | null;
  /**
   * Value 1 Amount
   */
  value1Amount?: number | null;
  /**
   * Value Code 2
   */
  valueCode2?: string | null;
  /**
   * Value 2 Amount
   */
  value2Amount?: number | null;
  /**
   * Value Code 3
   */
  valueCode3?: string | null;
  /**
   * Value 3 Amount
   */
  value3Amount?: number | null;
  /**
   * Condition Code 1
   */
  conditionCode1?: string | null;
  /**
   * Condition Code 2
   */
  conditionCode2?: string | null;
  /**
   * Condition Code 3
   */
  conditionCode3?: string | null;
  /**
   * Condition Code 4
   */
  conditionCode4?: string | null;
  /**
   * Condition Code 5
   */
  conditionCode5?: string | null;
  /**
   * Condition Code 6
   */
  conditionCode6?: string | null;
  /**
   * Condition Code 7
   */
  conditionCode7?: string | null;
  /**
   * Condition Code 8
   */
  conditionCode8?: string | null;
  /**
   * Condition Code 9
   */
  conditionCode9?: string | null;
  /**
   * Condition Code 10
   */
  conditionCode10?: string | null;
  /**
   * Condition Code 11
   */
  conditionCode11?: string | null;
  /**
   * Attending Provider
   */
  attendingProvider?: string | null;
  /**
   * Referring Provider
   */
  referringProvider?: string | null;
  /**
   * Supervising Provider
   */
  supervisingProvider?: string | null;
  /**
   * Location
   */
  location?: string | null;
  /**
   * Diagnosis 1 Code
   */
  diagnosis1Code?: string | null;
  /**
   * Diagnosis 1 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis1PresentOnAdmission?: string | null;
  /**
   * Diagnosis 2 Code
   */
  diagnosis2Code?: string | null;
  /**
   * Diagnosis 2 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis2PresentOnAdmission?: string | null;
  /**
   * Diagnosis 3 Code
   */
  diagnosis3Code?: string | null;
  /**
   * Diagnosis 3 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis3PresentOnAdmission?: string | null;
  /**
   * Diagnosis 4 Code
   */
  diagnosis4Code?: string | null;
  /**
   * Diagnosis 4 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis4PresentOnAdmission?: string | null;
  /**
   * Diagnosis 5 Code
   */
  diagnosis5Code?: string | null;
  /**
   * Diagnosis 5 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis5PresentOnAdmission?: string | null;
  /**
   * Diagnosis 6 Code
   */
  diagnosis6Code?: string | null;
  /**
   * Diagnosis 6 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis6PresentOnAdmission?: string | null;
  /**
   * Diagnosis 7 Code
   */
  diagnosis7Code?: string | null;
  /**
   * Diagnosis 7 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis7PresentOnAdmission?: string | null;
  /**
   * Diagnosis 8 Code
   */
  diagnosis8Code?: string | null;
  /**
   * Diagnosis 8 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis8PresentOnAdmission?: string | null;
  /**
   * Diagnosis 9 Code
   */
  diagnosis9Code?: string | null;
  /**
   * Diagnosis 9 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis9PresentOnAdmission?: string | null;
  /**
   * Diagnosis 10 Code
   */
  diagnosis10Code?: string | null;
  /**
   * Diagnosis 10 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis10PresentOnAdmission?: string | null;
  /**
   * Diagnosis 11 Code
   */
  diagnosis11Code?: string | null;
  /**
   * Diagnosis 11 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis11PresentOnAdmission?: string | null;
  /**
   * Diagnosis 12 Code
   */
  diagnosis12Code?: string | null;
  /**
   * Diagnosis 12 Present On Admission Indicator, valid values are: Yes, No, NoInformation, Undetermined or blank
   */
  diagnosis12PresentOnAdmission?: string | null;
}
